class SiteHeaderButton {
  constructor() {
    this.el = document.querySelector('.site-header')
    this.button = this.el.querySelector('.site-header__burger')
    this.menu = document.querySelector('.site-header__overlay')
    this.body = document.querySelector('body')

    this.button.addEventListener('click', () => {
      this.toggle()
    })
  }

  toggle() {
    this.body.classList.toggle('is-overflow')
    this.el.classList.toggle('is-active')
    this.button.classList.toggle('is-open')
    this.menu.classList.toggle('is-active')
  }
}

export default class SiteHeader {
  constructor() {
    this.header = document.querySelector('.site-header');
    new SiteHeaderButton();
    this.initScrollEvent();
  }

  initScrollEvent() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        this.header.classList.add('scroll');
      } else {
        this.header.classList.remove('scroll');
      }
    });
  }
}